import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Routes } from "react-router-dom";
import * as Pages from "./pages/";
import { LanguageProvider } from "./utils/Language";

function App() {
  return (
    <LanguageProvider>
      <div className="container-fluid App">
        <Routes>
          <Route
            path="/"
            element={
              <Pages.ProtectedPage showNavbar={true}>
                <Pages.Home />
              </Pages.ProtectedPage>
            }
          />
          <Route
            path="/products"
            element={
              <Pages.ProtectedPage>
                <Pages.Products />
              </Pages.ProtectedPage>
            }
          />
          <Route
            path="/patients"
            element={
              <Pages.ProtectedPage showNavbar={true}>
                <Pages.PatientList />
              </Pages.ProtectedPage>
            }
          />
          <Route
            path="/work-receipt"
            element={
              <Pages.ProtectedPage showNavbar={true}>
                <Pages.WorkReceiptPage />
              </Pages.ProtectedPage>
            }
          />
          <Route
            path="/patients/:Id"
            element={
              <Pages.ProtectedPage showNavbar={true}>
                <Pages.PatientDetail />
              </Pages.ProtectedPage>
            }
          />
          <Route
            path="/action/:Id"
            element={
              <Pages.ProtectedPage showNavbar={false}>
                <Pages.ActionDetail />
              </Pages.ProtectedPage>
            }
          />
          <Route
            path="/actionkargo/:Id"
            element={
              <Pages.ProtectedPage showNavbar={false}>
                <Pages.ActionKargoDetail />
              </Pages.ProtectedPage>
            }
          />
          <Route path="/simulation" element={<Pages.AnonimSimulationViewerPage />} />
          <Route path="/team" element={<p>public page: team</p>} />
          <Route path="/login" element={<Pages.LoginPage />} />
          <Route path="/register" element={<Pages.RegisterPage />} />
          <Route
            path="/forgotpassword"
            element={<Pages.ForgotPasswordPage />}
          />
          <Route path="/logout" element={<Pages.LogoutPage />} />
          <Route
            path="/profile"
            element={
              <Pages.ProtectedPage showNavbar={true}>
                <Pages.ProfilePage />
              </Pages.ProtectedPage>
            }
          />
          <Route
            path="/newpatient/:id"
            element={
              <Pages.ProtectedPage showNavbar={true}>
                <Pages.NewPatientPage />
              </Pages.ProtectedPage>
            }
          />
          <Route
            path="/patientfiles"
            element={
              <Pages.ProtectedPage showNavbar={true}>
                <Pages.PatientFilesPage />
              </Pages.ProtectedPage>
            }
          />
          <Route path="*" element={<Pages.NotFound />} />
        </Routes>
      </div>
    </LanguageProvider>
  );
}

export default App;
